import * as _ from 'lodash'
import Vue from 'vue'
import moment from 'moment'

const SET_AUTH_CLINICAL_SERVICE = (state, service) => {
  state.authClinicalService = service
}

const METRICS_UPDATED = (state, metrics) => {
  state.metrics = {
    averageCallDuration: parseInt(metrics.averageCallDuration),
    averageWaitingTime: parseInt(metrics.averageWaitingTime),
    ongoingCalls: parseInt(metrics.ongoingCalls)
  }
}

const SET_ONLINE_AUDIOLOGISTS = (state, onlineAudiologistsByEntity) => {
  onlineAudiologistsByEntity.forEach(element => {
    // Remove from list if exists
    state.onlineAudiologistsByEntity = state.onlineAudiologistsByEntity.filter(item => item.entity_id !== element.entity_id)
    // Re-add to list if number of onlineAudiologists is above > 0
    if (element.onlineAudiologists !== 0) {
      state.onlineAudiologistsByEntity.push(element)
    }
  })
}

const SET_REQUESTS = (state, { requests }) => {
  state.requests = requests.map((request, index) => {
    return {
      ...request,
      positionInQueue: index + 1
    }
  })
}

const REQUEST_CREATED = (state, { request }) => {
  state.requests = [...state.requests, request]
}

const updateRequest = (state, request) => {
  if (request.acceptee) {
    state.requests = state.requests.filter(_request => _request.id !== request.id)
  } else {
    let index = state.requests.findIndex(_request => _request.id === request.id)
    if (index !== -1) {
      Vue.set(state.requests, index, request)
    } else {
      state.requests = [...state.requests, request]
    }
  }
}

const REQUEST_UPDATED = (state, { request }) => {
  updateRequest(state, request)
}

const REQUESTS_UPDATED = (state, { requests }) => {
  requests.forEach(request => {
    updateRequest(state, request)
  })
}

const REQUEST_DELETED = (state, { request }) => {
  state.requests = state.requests.filter(_request => _request.id !== request.id)
}

/* Pending Request Handling */

const SET_PENDING_REQUEST = (state, { request }) => {
  state.pendingRequest = request
}

const SET_PENDING_REQUEST_APPOINTMENT = (state, { appointment }) => {
  state.pendingRequest = { ...state.pendingRequest, appointment }
}

const SET_PENDING_REQUEST_CALL = (state, { call }) => {
  state.pendingRequest = { ...state.pendingRequest, call }
}

const UPDATE_PENDING_REQUEST_CALL_WAITING_TIME = (state, { estimatedAcceptTime }) => {
  let pendingRequestCall = _.get(state, 'pendingRequest.call', null)

  if (pendingRequestCall !== null) {
    if (pendingRequestCall.estimated_accept_time === null) {
      pendingRequestCall.estimated_accept_time = estimatedAcceptTime
    } else {
      const oldEstimatedAcceptTime = moment(pendingRequestCall.estimated_accept_time)
      const newEstimatedAcceptTime = moment(estimatedAcceptTime)
      let newTimestamp = oldEstimatedAcceptTime.valueOf()

      if (newEstimatedAcceptTime.isAfter(oldEstimatedAcceptTime)) {
        newTimestamp = (oldEstimatedAcceptTime.valueOf() + newEstimatedAcceptTime.valueOf()) / 2
      } else if (newEstimatedAcceptTime.isBefore(oldEstimatedAcceptTime)) {
        newTimestamp = (oldEstimatedAcceptTime.valueOf() * 0.8) + (newEstimatedAcceptTime.valueOf() * 0.2)
      }

      pendingRequestCall.estimated_accept_time = moment(newTimestamp).format()
    }
  }

  state.pendingRequest.call = pendingRequestCall
}

const RESET_PENDING_REQUEST = (state) => {
  state.pendingRequest = null
}

/* Active Request Handling */

const SET_ACTIVE_REQUEST = (state, { request }) => {
  state.activeRequest = request
}

const SET_ACTIVE_REQUEST_APPOINTMENT = (state, { appointment }) => {
  state.activeRequest = { ...state.activeRequest, appointment }
}

const SET_ACTIVE_REQUEST_CALL = (state, { call }) => {
  state.activeRequest = { ...state.activeRequest, call }
}

const RESET_ACTIVE_REQUEST = (state) => {
  state.activeRequest = null
}

/* Active Appointment Handling */

const SET_ACTIVE_APPOINTMENTS = (state, { appointments }) => {
  state.activeAppointments = appointments
}

const ADD_ACTIVE_APPOINTMENT = (state, { appointment }) => {
  if (!state.activeAppointments.some(item => item.id === appointment.id)) {
    state.activeAppointments.push(appointment)
  }
}

const REMOVE_ACTIVE_APPOINTMENT = (state, { appointment }) => {
  state.activeAppointments = state.activeAppointments.filter(item => item.id !== appointment.id)
}

const SET_CURRENT_ACTIVE_APPOINTMENT = (state, { appointment }) => {
  state.currentActiveAppointment = appointment
}

const RESET_CURRENT_ACTIVE_APPOINTMENT = (state) => {
  state.currentActiveAppointment = null
}

/* Active Break Handling */

const SET_ACTIVE_BREAK = (state, { _break }) => {
  state.activeBreak = _break
}

const RESET_ACTIVE_BREAK = (state) => {
  state.activeBreak = null
}

/* Active Request Unsaved Changes */

const SET_ACTIVE_APPOINTMENT_UNSAVED_PERSON_CHANGES = (state, { hasUnsavedChanges }) => {
  state.activeRequestHasUnsavedPersonChanges = hasUnsavedChanges
}

const SET_ACTIVE_APPOINTMENT_UNSAVED_APPOINTMENT_CHANGES = (state, { hasUnsavedChanges }) => {
  state.activeRequestHasUnsavedAppointmentChanges = hasUnsavedChanges
}

const RESET_ONLINE_AUDIOLOGISTS = (state) => {
  state.onlineAudiologistsByEntity = []
}

const RESET_REQUESTS = (state) => {
  state.requests = []
}

const HANDLE_MINIMIZED_CALL_COLLAPSED = (state) => {
  state.minimizedCallCollapsed = !state.minimizedCallCollapsed
}

const SET_LOADING = (state, { isLoading }) => {
  state.isLoading = isLoading || false
}

export default {
  SET_AUTH_CLINICAL_SERVICE,
  SET_REQUESTS,
  REQUEST_CREATED,
  REQUEST_UPDATED,
  REQUESTS_UPDATED,
  REQUEST_DELETED,
  RESET_REQUESTS,
  METRICS_UPDATED,
  RESET_ONLINE_AUDIOLOGISTS,
  SET_ONLINE_AUDIOLOGISTS,
  SET_PENDING_REQUEST,
  SET_PENDING_REQUEST_APPOINTMENT,
  SET_PENDING_REQUEST_CALL,
  RESET_PENDING_REQUEST,
  SET_ACTIVE_REQUEST,
  SET_ACTIVE_REQUEST_APPOINTMENT,
  SET_ACTIVE_REQUEST_CALL,
  RESET_ACTIVE_REQUEST,
  SET_ACTIVE_APPOINTMENTS,
  ADD_ACTIVE_APPOINTMENT,
  REMOVE_ACTIVE_APPOINTMENT,
  SET_CURRENT_ACTIVE_APPOINTMENT,
  RESET_CURRENT_ACTIVE_APPOINTMENT,
  UPDATE_PENDING_REQUEST_CALL_WAITING_TIME,
  SET_ACTIVE_APPOINTMENT_UNSAVED_PERSON_CHANGES,
  SET_ACTIVE_APPOINTMENT_UNSAVED_APPOINTMENT_CHANGES,
  SET_ACTIVE_BREAK,
  RESET_ACTIVE_BREAK,
  SET_LOADING,
  HANDLE_MINIMIZED_CALL_COLLAPSED
}
